import { Checkbox, DefaultButton, IconButton, Modal, PrimaryButton } from '@fluentui/react'
import React from 'react';
import "./styles/ConfirmModalCss.css";
import ModalHeader from './ModalHeader';
import ModalFooter from './ModalFooter';
import ModalMain from './ModalMain';

const ConfirmModal = (props) => {  

      let PrimaryButtonList = [
        {
            title:props.confirmButtonText,
            onclick: props.handleConfirm,
        }
      ];
      let DefaultButtonList = [
        {
            title:props.cancelButtonText == undefined ? "No" : props.cancelButtonText,
            onclick: props.handleNotConfirm
        }
      ];

      const modalDetails = {
        header: <ModalHeader updatedModal={true} patientName={props.patientName} patientID={props.patientId} heading={props.title} handleCancel={props.handleCloseIcon == undefined ? props.handleNotConfirm : props.handleCloseIcon}/>,
        footer : <ModalFooter PrimaryButtonList={PrimaryButtonList} DefaultButtonList={props.handleNotConfirm?DefaultButtonList:[]}/>,
        body : <>
        <div className='confirm-modal-content'>
                    <div className='message-container'>
                        <h1 className='confirm-message'>{props.message.split('\n').map((line, idx) => (
                          <p key={idx}>{line}</p>
                        ))}</h1>
                    </div>

          {props.showCheckbox && (
          <div className="checkbox-container" style={{ marginTop: '16px' }}>
            <Checkbox
              label={props.checkboxLabel}
              checked={props.checkboxChecked}
              onChange={(e, checked) => props.onCheckboxChange?.(checked)}
            />
          </div>
        )}
                </div></>,
        width : "600px"
      }

  return (
    <>
     {props.showConfirmModal && 
     <ModalMain updatedModal={true} showModal={props.showConfirmModal} modalDetails={modalDetails}/>
     }
    </>
  )
}

export default ConfirmModal